module.exports = "<div class=\"pending-invite-modal-container\">\n  <div class=\"pending-invite-modal-text\">\n    Welcome back {{currentUserFirstName}} You have {{pendingInvitations}} pending invitations don't forget to chase those people up\n  </div>\n  <div class=\"pending-invite-modal-close\">\n    <button (click)=\"close()\">\n      Close\n    </button>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pending-invite-reminder/pending-invite-reminder.component.html
// module id = ./src/app/pending-invite-reminder/pending-invite-reminder.component.html
// module chunks = main